import React, { useState } from 'react';
import '../../purchase.css';
import axios from 'axios';

const PurchaseModel = ({ show, onClose, model, purchasedModels }) => {
    const [loading, setLoading] = useState(false);
    const [isPurchased, setIsPurchased] = useState(false);

    if (!show) return null;

    const handlePurchaseNow = async () => {
        try {
            setLoading(true);
            const user = JSON.parse(localStorage.getItem('user'));

            let requestBody;
            requestBody = {
                    models: [...new Set([...purchasedModels, model._id])]
                };

            const response = await axios.put(`https://geoid-rest.vercel.app/users/${user.user._id}`, requestBody);
            setIsPurchased(true);
        } catch (error) {
            console.error("There was an error updating purchase!", error);
        } finally {
            setLoading(false);
        }
    };

    const isAlreadyPurchased = Array.isArray(purchasedModels) && purchasedModels.length > 0 && purchasedModels.includes(model._id);

    return (
        <div className="modal-overlay">
        {loading && (
            <div className="register-loading-overlay">
            <div className="register-spinner"></div>
            </div>
        )}
        {isPurchased || isAlreadyPurchased ? ( // Conditional rendering based on purchase status
            <>
            <div className="modal-content">
                <button className="modal-close-button-purchase" onClick={onClose}>
                    &times;
                </button>
                <p>You purchased this report</p>
                <button className="purchase-button" onClick={() => window.open(model.model, '_blank')}>
                    Download
                </button>
            </div>
            </>
       ) : (
        <div className="modal-content">
            {/* Close Button */}
            <button className="modal-close-button-purchase" onClick={onClose}>
                &times;
            </button>
            <h2>{model.data.title}</h2>
            <p>Age: {model.data.age}</p>
            <p>Location: {model.data.origin}</p>
            <p><strong>Price: RM 100</strong></p>
            <button className="purchase-button" onClick={() => handlePurchaseNow()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cash-stack" viewBox="0 0 16 16">
                    <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                    <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z"/>
                </svg>&nbsp;
                Purchase Now
            </button>
        </div>
       )}
        </div>
    );
};

export default PurchaseModel;